import { render, staticRenderFns } from "./index7.vue?vue&type=template&id=54c15545&scoped=true&"
import script from "./index7.vue?vue&type=script&lang=js&"
export * from "./index7.vue?vue&type=script&lang=js&"
import style0 from "./index7.vue?vue&type=style&index=0&id=54c15545&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c15545",
  null
  
)

export default component.exports